module.exports = __webpack_public_path__ + "static/media/in.ee625714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/in.jpg
// module id = 1293
// module chunks = 110